import React, { useState } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { FiShoppingBag, FiUsers, FiClock, FiMusic, FiLink, FiCreditCard, FiAlertCircle, FiPlus, FiHome, FiCloud } from "react-icons/fi";

const TermsCondtions = () => {
  AOS.init();

  return (
    <>
      <div className="inner-page-banner" data-aos="fade-down">
        <div className="banner-wrapper">
          <div className="container-fluid">
            <div className="banner-main-content-wrap">
              <div className="row">
                <div className="col-12">
                  <div className="banner-content">
                    <ul className="breadcrumb-list mt-5 pt-5 d-flex justify-content-center align-items-center">
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>Terms and Conditions</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="contact-page py-3 mt-2 mb-2">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="about-content" data-aos="fade-up">
                <h2 className="section-title mb-4">TERMS AND CONDITIONS</h2>
                <div className="terms-list">
                  <div className="term-item d-flex align-items-start mb-3">
                    <FiShoppingBag className="me-3 mt-1" style={{ fontSize: '20px', color: '#efb93f' }} />
                    <span>Cake should be bought by the clients</span>
                  </div>
                  <div className="term-item d-flex align-items-start mb-3">
                    <FiUsers className="me-3 mt-1" style={{ fontSize: '20px', color: '#efb93f' }} />
                    <span>Twins are chargeable at <strong><em>150% of the price</em></strong></span>
                  </div>
                  <div className="term-item d-flex align-items-start mb-3">
                    <FiClock className="me-3 mt-1" style={{ fontSize: '20px', color: '#efb93f' }} />
                    <span>Edited images will be given within <strong><em>one week</em></strong> after selection. Edited Video will take <strong><em>7-10 days</em></strong>. Any changes in the edited video will be done <strong><em>only once</em></strong></span>
                  </div>
                  <div className="term-item d-flex align-items-start mb-3">
                    <FiMusic className="me-3 mt-1" style={{ fontSize: '20px', color: '#efb93f' }} />
                    <span>Song suggestions for video will be done by us. If you have any particular song please inform us in the prior. Once song is confirmed it cannot be changed for any reasons</span>
                  </div>
                  <div className="term-item d-flex align-items-start mb-3">
                    <FiLink className="me-3 mt-1" style={{ fontSize: '20px', color: '#efb93f' }} />
                    <span>All images will be shared through link, raw videos we didn't provide</span>
                  </div>
                  <div className="term-item d-flex align-items-start mb-3">
                    <FiCreditCard className="me-3 mt-1" style={{ fontSize: '20px', color: '#efb93f' }} />
                    <span>The session will be considered after booking deposit <strong><em>20% of the session price</em></strong> and full payment to be cleared after shoot</span>
                  </div>
                  <div className="term-item d-flex align-items-start mb-3">
                    <FiAlertCircle className="me-3 mt-1" style={{ fontSize: '20px', color: '#efb93f' }} />
                    <span>The advance amount paid cannot be refunded or transferred in case of cancellation of the shoot you can postpone the shoot. Postponed shoot must not done at <strong><em>weekends</em></strong> (<strong><em>week days only we do</em></strong>)</span>
                  </div>
                  <div className="term-item d-flex align-items-start mb-3">
                    <FiPlus className="me-3 mt-1" style={{ fontSize: '20px', color: '#efb93f' }} />
                    <span>In case of additional images to be edited, they are chargeable (<strong><em>500 for 10 photos</em></strong>)</span>
                  </div>
                  <div className="term-item d-flex align-items-start mb-3">
                    <FiHome className="me-3 mt-1" style={{ fontSize: '20px', color: '#efb93f' }} />
                    <span>For indoor shoot family members only allowed. Out door only we allow gp</span>
                  </div>
                  <div className="term-item d-flex align-items-start mb-3">
                    <FiCloud className="me-3 mt-1" style={{ fontSize: '20px', color: '#efb93f' }} />
                    <span>Edited and raw data will be stored with us only for <strong><em>One month</em></strong> after the date of the shoot. Please download your high quality edited and raw images within <strong><em>one week</em></strong> from the date of transfer from our end. The download link expires in few days once we send</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsCondtions;
